export const pluralize = (word) => {
  const pluralMap = {
    category: "categories",
    product: "products",
    valuePack: "valuePacks"
  };

  const key = word.toLowerCase();
  if (pluralMap[key]) return pluralMap[key];

  if (key.endsWith("y")) return key.slice(0, -1) + "ies";
  if (!key.endsWith("s")) return key + "s";

  console.log("finalKey : ", key);
  return key;
};
